import { Link } from "react-router-dom";
import { Icon } from "../components/Icon";
import { useAuth } from "../context/AuthContext";

export function NotFoundPage() {
  const { status } = useAuth();
  return (
    <main className="not-found-page">
      <span>404 / LOST ROUTE</span>
      <h1>这条路径没有连接到工作台。</h1>
      <p>页面可能已移动，任务本身不会因此中断。</p>
      <Link className="button button--primary" to={status === "authenticated" ? "/overview" : "/login"}>返回入口 <Icon name="arrow" size={18} /></Link>
    </main>
  );
}
